import { useState } from 'react';
import { faqs } from '@/mocks/faqs';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              kicker="常见问题"
              title="吃瓜之前，你可能想问"
              desc="关于信息来源、小号判断和隐私边界，我们把常被问到的六个问题整理在这里。"
            />
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-300 border-y border-background-300">
              {faqs.map((item, index) => {
                const isOpen = open === index;
                return (
                  <Reveal key={item.q} delay={index * 40}>
                    <div>
                      <dt>
                        <button
                          type="button"
                          aria-expanded={isOpen}
                          onClick={() => setOpen(isOpen ? null : index)}
                          className="flex w-full cursor-pointer items-center justify-between gap-4 py-5 text-left"
                        >
                          <span className="font-heading text-base font-bold text-foreground-950">
                            {item.q}
                          </span>
                          <i
                            className={`shrink-0 text-xl text-primary-600 transition-transform ${
                              isOpen ? 'ri-subtract-line' : 'ri-add-line'
                            }`}
                          />
                        </button>
                      </dt>
                      {isOpen && (
                        <dd className="pb-5 pr-8 text-sm leading-relaxed text-foreground-600">{item.a}</dd>
                      )}
                    </div>
                  </Reveal>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}